export type SendShortcutEvent = {
  key: string;
  shiftKey: boolean;
  nativeEvent: { isComposing: boolean };
};

// Enter sends the message; Shift+Enter and Enter that confirms an IME
// composition do not.
export const isSendShortcut = (event: SendShortcutEvent): boolean =>
  event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing;
